import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { partDetailsJobsConfig } from './config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';

const PartDetailsJobStack = createStackNavigator();

const PartDetailsJobNavigator = () => {
  return (
    <PartDetailsJobStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {partDetailsJobsConfig.map(({ Component, name }) => (
        <PartDetailsJobStack.Screen key={name} name={name} component={Component} />
      ))}
    </PartDetailsJobStack.Navigator>
  );
};

export { PartDetailsJobNavigator };
